var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"count flex-column flex-center"},[_c('div',[_vm._v(_vm._s(_vm.value || _vm.value === 0 ? _vm.value : '-'))]),_c('p',[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }